import axios from "axios";

export const setAuthToken = token => {
  if (token) {
    // Apply authorization token to every request if logged in
    axios.defaults.headers.common["Authorization"] = token;
  } else {
    // Delete auth header
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const getApiUrl = () => {
  if (typeof window === 'undefined') {
    return ''; // Return empty string or handle SSR case if needed
  }

  const host = window.location.hostname;

  if (host === 'portal.zimtra.ky' || host === 'portal.zimtra.com') {
    return 'https://api.zimtra.com'; // Production URL
  }
  if (host === 'localhost') {
    return 'https://dev.api.zimtra.com';
  }
  
  return 'https://dev.api.zimtra.com'; // prod test api
};
